"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7389],{

/***/ 77389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_RecruitmentProcessCareers; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./components/sections/RecruitmentProcessCareers/recruitmentProcessCareers.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    overflow-x: auto;\n    flex-direction: row;\n    padding-bottom: 0.5rem;\n\n    ::-webkit-scrollbar {\n      height: 5px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n      background: #888;\n    }\n\n    /* Handle on hover */\n    ::-webkit-scrollbar-thumb:hover {\n      background: #555;\n    }\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "enwplf30"
})("display:flex;flex-direction:column;", mixins/* defaultContainerSize */.sX, ";margin-top:4rem;margin-bottom:4rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "enwplf31"
})("font-weight:400;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:2rem;line-height:2.5rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const ProcessList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "enwplf32"
})("display:flex;flex-direction:column;width:100%;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");

// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/RecruitmentProcessCareers/ProcessItem/processItem.styles.tsx

function processItem_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 1rem;\n    margin-bottom: 0;\n  "
    ]);
    processItem_styles_templateObject = function() {
        return data;
    };
    return data;
}
function processItem_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: rotate(0deg);\n    "
    ]);
    processItem_styles_templateObject1 = function() {
        return data;
    };
    return data;
}



const ProcessItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tvpfm00"
})("min-width:13.425rem;display:flex;flex-direction:column;align-items:center;text-align:center;gap:1rem;");
const ItemDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1tvpfm01"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:700;font-size:1rem;line-height:1.5rem;letter-spacing:0.0125rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0;");
const Divider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tvpfm02"
})("display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:1.0625rem 0;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(processItem_styles_templateObject())), ";svg{transform:rotate(90deg);", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(processItem_styles_templateObject1())), ";}");

;// CONCATENATED MODULE: ./components/sections/RecruitmentProcessCareers/ProcessItem/ProcessItem.tsx




const ProcessItem = (param)=>{
    let { title , image , description , index , itemsLength  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProcessItemWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        ...(0,imageSerializer/* imageSerializer */.l)(image)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemDescription, {
                        children: description
                    })
                ]
            }),
            index < itemsLength - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M9.79688 18.5L15.7969 12.5L9.79688 6.5",
                        stroke: "#667070",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/RecruitmentProcessCareers/RecruitmentProcessCareers.tsx




const RecruitmentProcessCareers = (param)=>{
    let { titleAs , title , items  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                as: titleAs && titleAs,
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessList, {
                children: items.map((param, index)=>{
                    let { recruitment_image , recruitment_title , recruitment_description  } = param;
                    const title = prismic_reactjs.RichText.asText(recruitment_title);
                    const description = prismic_reactjs.RichText.asText(recruitment_description);
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessItem, {
                        itemsLength: items.length,
                        title: title,
                        description: description,
                        image: recruitment_image,
                        index: index
                    }, title + index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/RecruitmentProcessCareers/index.ts

/* harmony default export */ var sections_RecruitmentProcessCareers = (RecruitmentProcessCareers);


/***/ })

}]);